<template>
    <div class="loading-page" :class="{'ac-bg-gray': ac}">
       <header-component 
            :is-soon="false"
			img-left="/trocachip/img/setinha-left-preto.svg"
			img-right="/trocachip/img/access.png"
			class="header-component"
       />
       <div class="loading-page-content">
            <strong v-html="title"></strong>
            <loader-page class="loading_page_indicador" id="loading_page_indicador" :isBlue="true"/>
       </div>
    </div>
</template>

<script>
import HeaderComponent from "../components/HeaderComponent";
import {mapState} from "vuex";
import LoaderPage from '../components/LoaderPage.vue';
import eSim from "../services/eSim";
import Order from "../services/order";

export default {
   name: "loading-page",
   components: {
       HeaderComponent,
       LoaderPage,
   },
   props: {
       title: { type: String, default: "Aguarde enquanto estamos concluindo sua solicitação" },
   },
   computed: {
       ...mapState({
            ac: state => state.ac,
            customer: state => state.customer,
            config: state => state.config,
            eligibilityErrorsCount: state => state.eligibilityErrorsCount,
            pinToken: state => state.pinToken,
            code: state => state.code,
            reason: state => state.reason
       })
   },
   created() {
        this.callReserveEsim();
   },
   methods: {
        callReserveEsim() {
            eSim.reservaEsim().then((response) => {
                if (!response.data) this.redirectToErrorPage();

                this.$store.dispatch("urlEsim", response.data.url);
                this.$store.dispatch("iccidEsim", response.data.simCard.iccid);
                this.callCreateOrder(response.data.simCard.iccid, response.data.url);
            }).catch(() => {
                this.redirectToErrorPage();
            })
        },
        callCreateOrder(iccid, urlEsim) {
            Order.getOrder(this.code, this.pinToken, iccid, this.reason, urlEsim).then(response => {
                if(response.data.internalCode == "1") {
                    this.$store.dispatch('protocol', response.data.protocol)
                    this.$router.push('/ativado-esim')
                } else {
                    this.redirectToErrorPage();
                }
            }).catch(() => {
                this.redirectToErrorPage();
            })
        },
        redirectToErrorPage() {
            this.$router.push({ name: "default-error" })
        },
        returnHome() {
            this.$router.push({ name: "welcome" })
        }
   }
}
</script>

<style lang="scss" scoped>
.loading-page {
   width: 100vw;
   margin-top: 100px;
   display: flex;
   align-items: center;
   justify-content: center;
}
.loading_page_indicador {
    margin-top: 50px;
    width: 40px;
    height: 40px;
}

.loading-page-content {
   width: 100%;
   display: flex;
   flex-direction: column;
   align-items: center;
   font-family: 'timsans_regular';
   text-align: center;
}

.loading-page-content strong {
   font-size: 24px;
   font-weight: 300;
   margin-top: 50px;
   line-height: 35px;
}

.loading-page-content span {
   margin-top: 27px;
   opacity: 0.6;
   font-size: 16px;
   color: #000000;
   width: 75%;
}
</style>
